import React from 'react'
import { connect } from 'react-redux'

import UserSettings from './usersettings'

import './index.css'

class Settings extends React.Component {
  render() {
    return (
      <div className="settings-wrapper">
        <UserSettings />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
